module.exports = __webpack_public_path__ + "static/media/cl_trade_arrow_grey.54da8fb4.svg";